/* eslint-disable no-unused-vars */
import { defineAbility } from '@casl/ability'

export default defineAbility((can) => {})
